import React from 'react';
import { Chip } from '@mui/material';

interface PurchaseStatusBadgeProps {
  status: 'NEW' | 'CONTACTED' | 'FOLLOW_UP' | 'CONVERTED' | 'LOST';
}

export const purchaseStatusColors = {
  NEW: '#2196f3',
  CONTACTED: '#ff9800',
  FOLLOW_UP: '#9c27b0',
  CONVERTED: '#4caf50',
  LOST: '#f44336',
};

export const purchaseStatusLabels = {
  NEW: 'New',
  CONTACTED: 'Contacted',
  FOLLOW_UP: 'Follow Up',
  CONVERTED: 'Converted',
  LOST: 'Lost',
};

const statusColors = purchaseStatusColors;
const statusLabels = purchaseStatusLabels;

const PurchaseStatusBadge: React.FC<PurchaseStatusBadgeProps> = ({
  status,
}) => {
  const color = statusColors[status];

  return (
    <Chip
      label={statusLabels[status]}
      sx={{
        backgroundColor: `${color}15`,
        color,
        border: `1px solid ${color}25`,
        fontWeight: 700,
        fontSize: '11px',
        height: '24px',
        minWidth: '80px',
      }}
      size="small"
    />
  );
};

// ADD THIS EXPORT
export default PurchaseStatusBadge;
